import { Grid, Skeleton, Stack } from '@mui/material';
import { BarChartSkeleton } from '../../skeleton-components/bar-chart-skeleton';
import { DonutChartSkeleton } from '../../skeleton-components/donut-chart-skeleton';

export const AnalyticsByLocationSkeleton = () => (
  <Grid container spacing={2}>
    <Grid item xl={4} lg={4} md={12} sm={12} xs={12}>
      <Stack spacing={2}>
        <DonutChartSkeleton height={420} />
      </Stack>
    </Grid>

    <Grid item xl={8} lg={8} md={12} sm={12} xs={12}>
      <BarChartSkeleton height={420} />
    </Grid>

    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
      <Skeleton variant="rectangular" height={516} sx={{ borderRadius: 1 }} />
    </Grid>
  </Grid>
);
